import { getMasterDataApi } from "../../components/pages/location/LocationRoute";
import {
  API_ACCOUNTS_ROLES,
  API_CUSTOMER_REPORT_REQUESTS,
  API_LIQUIDATIONS,
  API_PARTNER_ITEM_MAPPING,
  API_MARK_TRANSACTION,
  API_REGISTER_AGENT,
  API_REGISTER_MERCHANT,
  API_REGISTER_STAFF,
  API_REVERSE_TRANSACTIONS,
  API_USERS,
  API_DEBIT_HOLDINGS,
  API_CREDIT_HOLDINGS,
} from "../../utils/apis";
import {
  objectWithUnsetKeys,
  prepareAttachmentsPost,
} from "../../utils/helpers";

export function submitUsers(payload: any, id: string) {
  const { role_name } = payload;

  const params = {
    ...objectWithUnsetKeys(payload, [
      "certificate_of_registration",
      "tin_certificate",
      "lc1_letter",
      "other",
    ]),
    ...prepareAttachmentsPost(
      [
        payload?.certificate_of_registration,
        payload?.tin_certificate,
        payload?.lc1_letter,
        payload?.other,
      ],
      "attachments",
    ),
  };

  //  UPDATE
  if (id) {
    return {
      id,
      api: API_USERS,
      params,
    };
  }
  // CREATE
  return {
    // api: role_name === "Agent" ? API_REGISTER_AGENT : API_REGISTER_MERCHANT,
    api:
      role_name === "Agent"
        ? API_REGISTER_AGENT
        : role_name === "Merchant"
          ? API_REGISTER_MERCHANT
          : API_REGISTER_STAFF,
    params,
    type: "multipart/form-data",
  };
}

export function submitRoles(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_ACCOUNTS_ROLES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_ACCOUNTS_ROLES,
    params: {
      ...payload,
    },
  };
}

export function submitReverseTransactions(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_REVERSE_TRANSACTIONS,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_REVERSE_TRANSACTIONS,
    params: {
      ...payload,
    },
  };
}

export function submitPartnerItemMapping(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_PARTNER_ITEM_MAPPING,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_PARTNER_ITEM_MAPPING,
    params: {
      ...payload,
    },
  };
}

export function submitMarkTransaction(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_MARK_TRANSACTION,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_MARK_TRANSACTION,
    params: {
      ...payload,
    },
  };
}

export function submitLiquidations(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: `${API_LIQUIDATIONS}`,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: `${API_LIQUIDATIONS}`,
    params: {
      ...payload,
    },
  };
}
export function submitDebitHolding(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: `${API_DEBIT_HOLDINGS}`,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: `${API_DEBIT_HOLDINGS}`,
    params: {
      ...payload,
    },
  };
}
export function submitCreditHolding(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: `${API_CREDIT_HOLDINGS}`,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: `${API_CREDIT_HOLDINGS}`,
    params: {
      ...payload,
    },
  };
}

export function submitMasterData(payload: any, id: string) {
  //  on update
  if (id) {
    const location_type = window.location.pathname.split("/")[1];
    return {
      id,
      api: getMasterDataApi(location_type),
      params: {
        name: payload?.name,
        region: payload?.region,
        district: payload?.district,
        parent: payload?.parent, // counties, division, parish, village
      },
    };
  }
  // on create
  return {
    api: getMasterDataApi(payload?.location_type),
    params: payload,
  };
}

export function submitCustomerReportRequests(payload: any) {
  return {
    method: "POST",
    api: API_CUSTOMER_REPORT_REQUESTS,
    params: {
      ...payload,
    },
  };
}
